import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TransactionDetails.scss';
import { FcManager } from "react-icons/fc";
import transactionData from './transactionData.json';

const TransactionDetails = () => {
  const navigate = useNavigate();
  

  return (
    <div className="transaction-details">
      <div className="icon-wrapper">
      <FcManager className="transaction-icon"/>
      </div>
      <div className="content">
        <div className="line">
          <span>transaction number</span>          
        </div>        
        <div className="line">
          <span >Transaction currency</span>
          <span  >{transactionData.transaction_id}</span>
        </div>
        <div className="line">
          <span>Transaction currency</span>
          <span>{transactionData.订单详情}</span>
        </div>
        <div className="line">
          <span>payment method</span>
          <span>{transactionData.currency}</span>
        </div>
        <div className="line">
          <span>payment method</span>
          <span>{transactionData.payment_method}</span>
        </div>
        <div className="line">
          <span>order amount</span>
          <span>{transactionData.transaction_amount}</span>
        </div>
        <div className="line">
          <span>transaction fee</span>
          <span>{transactionData.transaction_fee}</span>
        </div>
        <div className="line">
          <span>order notes</span>
          <span>{transactionData.payment_note}</span>
        </div>
      </div>
      <button className="details-button" onClick={() => navigate('/CopyMain')}>order details</button>
    </div>
  );
};

export default TransactionDetails;
